/**
 * D365 BC journal import wire shapes. Match the BE handoff contract
 * (GET /api/integrations/d365bc/fiscal-years + POST /api/integrations/d365bc/import).
 *
 * The import RESULT shape is shared with other vendors (Abacus, future ones)
 * via `IJournalImportResult` in `./journal-import.model`.
 */

// ── GET /fiscal-years ───────────────────────────────────────────────────────

export interface IFiscalYear {
    /** e.g. 2024 */
    year: number;
    /** ISO YYYY-MM-DD */
    startDate: string;
    /** ISO YYYY-MM-DD (inclusive) */
    endDate: string;
    isClosed: boolean;
}

// ── POST /import ────────────────────────────────────────────────────────────

export interface ID365BcImportBody {
    companyId: string;
    connectionId: string;
    externalCompanyId: string;
    /** ISO YYYY-MM-DD */
    fiscalYearStart: string;
    fiscalYearEnd: string;
    /** Optional YoY pair — both halves or neither, BE rejects partial. */
    previousFiscalYearStart?: string;
    previousFiscalYearEnd?: string;
}
